import React from 'react';

import { PageTitle } from '../../../components';
import { Event, Heading } from '../../../components';
import { eventContent } from '../../../constants';

const EventPage = () => {  
  return (  
    <>  
      {/* Page Title */}
      <PageTitle title={'Events'} page={'Events'} />

      {/* Events Section */}
      <section className='events'>

        {/* Section heading */}
        <Heading title={'Upcoming Events'} subTitle={'Green Initiatives'} />

        <div className='box-container'>
          {/* Loop through the eventContent array and render each event */}
          {eventContent.map((event) => (
            <Event
              key={event.id} // Unique key for each event
              image={event.image} // Event image
              date={event.details.date} // Event date
              time={event.details.time} // Event time
              title={event.title} // Event title
              venue={event.details.location} // Event venue location
              event={event} // Pass the full event object
            />
          ))}
        </div>

      </section>
    </>
  );
}

export default EventPage;